export { default as History } from './History';



// WEBPACK FOOTER //
// ./src/history/index.js